__turbopack_context__.v({
  "bottomArea": "map-view-module__bF9hQW__bottomArea",
  "canvas": "map-view-module__bF9hQW__canvas",
  "card": "map-view-module__bF9hQW__card",
  "cardButtons": "map-view-module__bF9hQW__cardButtons",
  "cardForm": "map-view-module__bF9hQW__cardForm",
  "cardHeader": "map-view-module__bF9hQW__cardHeader",
  "cardKind": "map-view-module__bF9hQW__cardKind",
  "cardLink": "map-view-module__bF9hQW__cardLink",
  "cardOriginal": "map-view-module__bF9hQW__cardOriginal",
  "cardTitle": "map-view-module__bF9hQW__cardTitle",
  "dimmed": "map-view-module__bF9hQW__dimmed",
  "editing": "map-view-module__bF9hQW__editing",
  "error": "map-view-module__bF9hQW__error",
  "filterGroup": "map-view-module__bF9hQW__filterGroup",
  "filterMenu": "map-view-module__bF9hQW__filterMenu",
  "filterRow": "map-view-module__bF9hQW__filterRow",
  "hiddenTitle": "map-view-module__bF9hQW__hiddenTitle",
  "kind-building": "map-view-module__bF9hQW__kind-building",
  "kind-desert": "map-view-module__bF9hQW__kind-desert",
  "kind-district": "map-view-module__bF9hQW__kind-district",
  "kind-forest": "map-view-module__bF9hQW__kind-forest",
  "kind-gate": "map-view-module__bF9hQW__kind-gate",
  "kind-glacier": "map-view-module__bF9hQW__kind-glacier",
  "kind-hills": "map-view-module__bF9hQW__kind-hills",
  "kind-lake": "map-view-module__bF9hQW__kind-lake",
  "kind-mountains": "map-view-module__bF9hQW__kind-mountains",
  "kind-realm": "map-view-module__bF9hQW__kind-realm",
  "kind-region": "map-view-module__bF9hQW__kind-region",
  "kind-river": "map-view-module__bF9hQW__kind-river",
  "kind-road": "map-view-module__bF9hQW__kind-road",
  "kind-scale": "map-view-module__bF9hQW__kind-scale",
  "kind-sea": "map-view-module__bF9hQW__kind-sea",
  "kind-swamp": "map-view-module__bF9hQW__kind-swamp",
  "kind-terrain": "map-view-module__bF9hQW__kind-terrain",
  "kind-underdark-place": "map-view-module__bF9hQW__kind-underdark-place",
  "kind-underdark-region": "map-view-module__bF9hQW__kind-underdark-region",
  "kind-ward": "map-view-module__bF9hQW__kind-ward",
  "kind-water": "map-view-module__bF9hQW__kind-water",
  "label": "map-view-module__bF9hQW__label",
  "layersMenu": "map-view-module__bF9hQW__layersMenu",
  "legend": "map-view-module__bF9hQW__legend",
  "legendChip": "map-view-module__bF9hQW__legendChip",
  "legendList": "map-view-module__bF9hQW__legendList",
  "legendSwatch": "map-view-module__bF9hQW__legendSwatch",
  "legendText": "map-view-module__bF9hQW__legendText",
  "marker": "map-view-module__bF9hQW__marker",
  "measure": "map-view-module__bF9hQW__measure",
  "measuring": "map-view-module__bF9hQW__measuring",
  "overlay": "map-view-module__bF9hQW__overlay",
  "panel": "map-view-module__bF9hQW__panel",
  "placing": "map-view-module__bF9hQW__placing",
  "point": "map-view-module__bF9hQW__point",
  "pointMarker": "map-view-module__bF9hQW__pointMarker",
  "pointMoved": "map-view-module__bF9hQW__pointMoved",
  "regionShape": "map-view-module__bF9hQW__regionShape",
  "regionTooltip": "map-view-module__bF9hQW__regionTooltip",
  "result": "map-view-module__bF9hQW__result",
  "resultActive": "map-view-module__bF9hQW__resultActive",
  "resultOriginal": "map-view-module__bF9hQW__resultOriginal",
  "results": "map-view-module__bF9hQW__results",
  "road": "map-view-module__bF9hQW__road",
  "root": "map-view-module__bF9hQW__root",
  "scale": "map-view-module__bF9hQW__scale",
  "scaleBar": "map-view-module__bF9hQW__scaleBar",
  "selectBox": "map-view-module__bF9hQW__selectBox",
  "selected": "map-view-module__bF9hQW__selected",
  "separator": "map-view-module__bF9hQW__separator",
  "toolbar": "map-view-module__bF9hQW__toolbar",
  "toolbarArea": "map-view-module__bF9hQW__toolbarArea",
  "underdarkMode": "map-view-module__bF9hQW__underdarkMode",
  "vertex": "map-view-module__bF9hQW__vertex",
  "vertexSelected": "map-view-module__bF9hQW__vertexSelected",
  "vertexShared": "map-view-module__bF9hQW__vertexShared",
});
